import { SvgIcon } from '@mui/material';

const CreditCard = () => (
  <SvgIcon
    viewBox="0 0 24 25"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 24, height: 25, fill: 'none' }}
    data-testid="creditCardIcon"
  >
    <path
      d="M20 4.25293H4C2.89 4.25293 2.01 5.14293 2.01 6.25293L2 18.2529C2 19.3629 2.89 20.2529 4 20.2529H20C21.11 20.2529 22 19.3629 22 18.2529V6.25293C22 5.14293 21.11 4.25293 20 4.25293ZM20 18.2529H4V12.2529H20V18.2529ZM20 8.25293H4V6.25293H20V8.25293Z"
      fill="#4D5160"
    />
  </SvgIcon>
);

export default CreditCard;
